export default "__VITE_ASSET__QNLcIvN8__"